<template>
  <div class="ioc-tab-group">
    <el-tabs v-model="activeName"
             @tab-click="handleClick">
      <el-tab-pane :name="index.toString()"
                   v-for="(item,index) in option.column"
                   :label="item.label"
                   :key="index"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'IocTabGroup',
  props: {
    option: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      activeName: '0'
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleClick (val) {
      const index =  Number(val.index)
      this.$emit('change', this.option.column[index])
    },
    changeTabs(active) {
      this.activeName = active + "";
    },
    reset(){
      this.activeName='0'
    },
  }
}
</script>

<style lang="scss">
.ioc-tab-group {
  // display: flex;
  // flex-direction: column;
  // flex: 1;
  // min-height: 0;
}
</style>